import { Box, List, ListItem, Text, Icon } from "@chakra-ui/react";
import { ChatIcon } from "@chakra-ui/icons";
import { fetchpromptdataApi } from "../../../allApi/api";
import { useCustomTost } from "../../../utiils/useCustomTost";
import { useDispatch } from "react-redux";
import { propmtSaveDataFun } from "../../../redux/reducer/promptTestingReduce";

const PromptListItem = ({ promptData }) => {
  const toast = useCustomTost();
  const dispatch=useDispatch()
  const handlePromptClick = async (session_id) => {
    localStorage.setItem("propt_id", session_id);
    try {
      const responce = await fetchpromptdataApi({
        session_id: session_id,
      });
      dispatch(propmtSaveDataFun(responce?.data))

    } catch (error) {
      toast("An error occurred.", error, "error");
    }
  };
  return (
    <List spacing={3} position="relative">
      {promptData?.map((prompt, index) => (
        <ListItem
          key={prompt.id}
          display="flex"
          alignItems="center"
          cursor={"pointer"}
          onClick={() => handlePromptClick(prompt?.session_id)}
        >
          {/* Left Icon with Connector */}
          <Box
            position="relative"
            width="14px"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Icon as={ChatIcon} color="yellow.500" boxSize={3} />
            {/* {index !== prompts.length -1 && (
              <Box
                position="absolute"
                top="100%"
                width="1px"
                height="18px"
                bg="yellow.300"
              />
            )} */}
          </Box>
          {/* Text */}
          <Text ml={2} color={"#71738A "}>
            {prompt?.name}
          </Text>
        </ListItem>
      ))}
    </List>
  );
};

export default PromptListItem;
